import { Component, Vue, Prop } from 'vue-property-decorator'
import CommonConstans from '@/common/CommonConstants'
import $ from 'jquery'
@Component({
  name: 'Pagination'
  })
export default class PaginationController extends Vue {
  @Prop({ required: true }) readonly currentPage: number
  @Prop({ required: true }) readonly totalRecord: number
  @Prop({ required: true }) readonly pageSize: number
  isMobile = false

  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.$root.$on('renderTabIndexPage', this.setTabindex)
    this.$root.$on('renderEvent', this.setEventKeyDown)
  }

  /**
   * ページ数ボタン押下
   */
  private handleChangePage(page: number, target: any) {
    this.$emit('change-page', page)
    this.setTabindex()
    this.scrollToTop()
    // setTimeout(() => {
    //   target.focus()
    // }, 100)
  }

  private setTabindex() {
    setTimeout(() => {
      $('.btn-prev').attr('tabindex', '100')
      $('.btn-next').attr('tabindex', '100')
      $('.number').attr('tabindex', '100')
    }, 200)
  }

  /**
   * イベントキーダウンを設定する
   */
  private setEventKeyDown() {
    setTimeout(() => {
      const pages = $('.number')
      for (const page of pages) {
        page.removeEventListener('keydown', this.addEvent)
        page.addEventListener('keydown', this.addEvent)
      }
    }, 100)
  }

  /**
   * イベントキーダウンを設定する
   */
  private addEvent(event) {
    if (event.keyCode === 13) {
      this.handleChangePage(parseInt(event.currentTarget.innerHTML), event.currentTarget)
    }
  }

  /**
   * 前のページへボタン押下
   */
  private handlePreviousPage() {
    // @ts-ignore
    this.$refs.pagination.prev()
  }

  /**
   * 次のページへボタン押下
   */
  private handleNextPage() {
    // @ts-ignore
    this.$refs.pagination.next()
  }

  /**
   * Check responsive
   */
  private onResize() {
    this.isMobile = window.innerWidth < CommonConstans.RESPONSIVE_WIDTH_SP
  }

  // Before destroy instance
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  /**
   * 指定エリアまでスクロールする。
   */
  private scrollToTop() {
    setTimeout(
      () =>
        $('html, body').animate(
          {
            scrollTop: 0
          },
          300
        ),
      0
    )
  }
}
